/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';
import React from 'react';

import { _date } from '@mairistem/administres-utils';
import { Table } from '@mairistem/composants';

import type { Acte } from '@/types';

interface Props {
  acte: Acte;
}

const ActeTableLineMariage = ({ acte }: Props) => {
  let dateMariage = _date.short(acte.dateMariage);

  if (acte.heureMariage && acte.minuteMariage) {
    dateMariage += ` - ${_.padStart(acte.heureMariage, 2, '0')}:${_.padStart(acte.minuteMariage, 2, '0')}`;
  }

  return (
    <>
      <Table.Cell content={dateMariage} />
      <Table.Cell content={acte.conjoint1} />
      <Table.Cell content={acte.conjoint2} />
    </>
  );
};

export default ActeTableLineMariage;
